<div
  [ngClass]="{
    'tw-sticky tw-top-0 tw-z-50 tw-pb-4': sideNavService.open,
    'tw-pb-[calc(theme(spacing.8)_+_2px)]': !sideNavService.open,
  }"
  class="tw-px-2 tw-pt-2"
>
  <!-- absolutely position the link svg to avoid shifting layout when sidenav is closed -->
  <a
    [routerLink]="route()"
    class="tw-relative tw-p-3 tw-block tw-rounded-md tw-bg-transparent tw-outline-none tw-font-bold tw-h-full !tw-text-alt2 hover:tw-text-alt2 hover:tw-no-underline focus-visible:tw-ring focus-visible:tw-ring-inset focus-visible:tw-ring-text-alt2 hover:tw-bg-hover-contrast"
    [ngClass]="{
      '!tw-h-[55px] [&_svg]:!tw-w-[26px] [&_svg]:tw-inset-y-[theme(spacing.3)]':
        !sideNavService.open,
      'tw-w-56': sideNavService.open,
    }"
    [attr.aria-label]="label()"
    [title]="label()"
    routerLinkActive
    ariaCurrentWhenActive="page"
  >
    <div class="tw-flex tw-justify-center tw-items-center" aria-hidden="true">
      <i class="tw-w-6 tw-text-alt2 bwi bwi-lg {{ closedIcon() }}"></i>
      <span class="tw-truncate" *ngIf="sideNavService.open">{{ label() }}</span>
    </div>
  </a>
</div>
